import storage from 'utils/storage'

const env = typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : {}

const CHAT_ENDPOINT = String(env.VITE_CHAT_ENDPOINT || '').trim().replace(/\/$/, '')
const CHAT_UPLOAD_DOCUMENT_TYPE =
  String(env.VITE_CHAT_UPLOAD_DOCUMENT_TYPE || 'chat-attachment-timekeeping').trim() ||
  'chat-attachment-timekeeping'
const CHAT_UPLOAD_PREFIX = String(env.VITE_CHAT_UPLOAD_PREFIX || '').trim()

export const CHAT_UPLOAD_ACCEPT = 'image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.zip'
export const CHAT_MAX_UPLOAD_BYTES = 15 * 1024 * 1024

const toJson = async (response) => {
  try {
    return await response.json()
  } catch (_) {
    return {}
  }
}

export const uploadChatAttachment = async ({file, tenantId, roomId, authToken}) => {
  if (!CHAT_ENDPOINT) {
    throw new Error('Missing VITE_CHAT_ENDPOINT. Cannot request upload URL.')
  }
  if (!file) {
    throw new Error('No file selected.')
  }

  const token = authToken || storage.getToken()

  const requestBody = {
    file_type: file.type || 'application/octet-stream',
    file_name: file.name,
    file_size: file.size,
    documentType: CHAT_UPLOAD_DOCUMENT_TYPE,
    tenantId,
    roomId,
  }
  if (CHAT_UPLOAD_PREFIX) {
    requestBody.keyPrefix = CHAT_UPLOAD_PREFIX
  }

  const presignResponse = await fetch(`${CHAT_ENDPOINT}/uploads/presign`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      ...(token ? {Authorization: `Bearer ${token}`} : {}),
    },
    body: JSON.stringify(requestBody),
  })

  if (!presignResponse.ok) {
    const payload = await toJson(presignResponse)
    throw new Error(payload?.message || payload?.error || 'Unable to get upload URL.')
  }

  const presignPayload = await toJson(presignResponse)
  const uploadURL = String(presignPayload?.uploadURL || presignPayload?.uploadUrl || '').trim()
  if (!uploadURL) {
    throw new Error('Upload URL is missing from response.')
  }

  const uploadResponse = await fetch(uploadURL, {
    method: 'PUT',
    headers: file.type ? {'content-type': file.type} : undefined,
    body: file,
  })

  if (!uploadResponse.ok) {
    throw new Error('Upload to S3 failed.')
  }

  const downloadURL = String(presignPayload?.downloadURL || presignPayload?.downloadUrl || '').trim()

  return {
    url: downloadURL || uploadURL.split('?')[0],
    name: file.name,
    size: file.size,
    type: file.type,
    key: presignPayload?.documentKey || presignPayload?.documentFilename,
  }
}
